import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Inbox02 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="inbox-02">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.88939 5.13685C5.36099 3.85928 6.56982 3 7.93425 3H16.0657C17.4302 3 18.639 3.85928 19.1106 5.13685L21.9381 12.7966C21.979 12.9074 22 13.0247 22 13.1429V17.7143C22 19.514 20.5597 21 18.75 21H5.25C3.44028 21 2 19.514 2 17.7143V13.1429C2 13.0247 2.02095 12.9074 2.06188 12.7966L4.88939 5.13685ZM7.93425 5C7.42288 5 6.95267 5.32277 6.76563 5.82945L4.4351 12.1429H7.5C7.77641 12.1429 8.04049 12.2573 8.22954 12.4589L9.43323 13.7429H14.5668L15.7705 12.4589C15.9595 12.2573 16.2236 12.1429 16.5 12.1429H19.5649L17.2344 5.82945C17.0473 5.32277 16.5771 5 16.0657 5H7.93425ZM20 14.1429H16.9332L15.7295 15.4268C15.5405 15.6284 15.2764 15.7429 15 15.7429H9C8.72359 15.7429 8.45951 15.6284 8.27046 15.4268L7.06677 14.1429H4V17.7143C4 18.4393 4.57443 19 5.25 19H18.75C19.4256 19 20 18.4393 20 17.7143V14.1429Z"
                />
            </g>
        </SvgIcon>
    );
};
